<template>
    <div class="multi-selector">
      <h4
        v-if="name && !settings.noHeader"
        :class="{ 'text-danger': invalidFeedback }"
      >
        <b>{{name}}{{required ? '*' : ''}}</b>
      </h4>
      <p
        v-if="description && !settings.noHeader"
        :class="{ 'text-danger': invalidFeedback, 'text-muted': !invalidFeedback }"
      >
        {{description}}
      </p>
      <b-form-group :label="settings.noHeader ? name : 'Select Options'">
        <multiselect
          :value="value"
          @input="$emit('input', $event)"
          :options="options && options.length ? options :[]"
          :multiple="multiple"
          :group-select="false"
          :max="3"
          placeholder="Select some options"
          class="multiselect-rlnx"
        >
          <template v-slot:noResult>Option can not be found</template>
        </multiselect>
      </b-form-group>
    </div>
  </template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'MultiSelector',
  components: {
    Multiselect
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    max: {
      type: Number,
      default: 3
    },
    value: {
      default: () => null,
    },
    options: {
      type: Array,
      default: () => null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fatalErr: null,
    err: null,
  }),
};
</script>

  <style lang="scss">
  .multi-selector {
    .multiselect-rlnx {
      .multiselect__tags {
        height: auto;
      }
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/profile/MultiSelector.vue